import { useTranslation, ContextApi } from 'contexts/Localization'
import { useCountdownObj } from 'hooks/useCountdown'
import { QuestDetailNotice } from 'views/VvsGotchi/components/QuestDetailNotice'
import { QuestWithConfig } from 'state/vvsgotchi/models'
import {
  currentIgo,
  currentIgoStartTime,
  currentIgoEndTime,
  isGoldDiggerDisabled,
} from 'state/vvsgotchi/quests/goldDigger'

const GoldDiggerQuestDetailNotice: React.FC<{ quest: QuestWithConfig }> = ({ quest }) => {
  const { t } = useTranslation()

  if (isGoldDiggerDisabled()) {
    return (
      <QuestDetailNotice type="locked">
        {currentIgo
          ? t('IGO (%igoName%) has ended', { igoName: currentIgo.displayName || currentIgo.id })
          : t('No active IGO event')}
      </QuestDetailNotice>
    )
  }

  if (quest?.isCompleted) {
    return (
      <QuestDetailNotice type="success">
        {t("Congrats! You have completed this task. Let's go on more quests and keep earning EXP!")}
      </QuestDetailNotice>
    )
  }

  return <GoldDiggerQuestDetailCountDownNotice />
}

const GoldDiggerQuestDetailCountDownNotice = () => {
  const igoName = currentIgo.displayName || currentIgo.id
  const igoStarted = Date.now() > currentIgoStartTime.getTime()

  const { t } = useTranslation()
  const countdown = displayCountdown(useCountdownObj(igoStarted ? currentIgoEndTime : currentIgoStartTime), t)

  return (
    <QuestDetailNotice type="coming-soon">
      {igoStarted
        ? t('IGO (%igoName%) will end in %countdown%', { igoName, countdown })
        : t('IGO (%igoName%) will start in %countdown%', { igoName, countdown })}
    </QuestDetailNotice>
  )
}

export default GoldDiggerQuestDetailNotice

const displayCountdown = (timeExcerptMap: Record<string, number>, t: ContextApi['t']) => {
  if (timeExcerptMap.d > 0) return t('%d%d %h%hr', timeExcerptMap)
  if (timeExcerptMap.h > 0) return t('%h%hr %m%m', timeExcerptMap)
  return t('%m%m %s%s', timeExcerptMap)
}
